// src/pages/InventoryCounting/api/inventoryCountingApi.js
import axios from 'axios';
import { API_URL } from '../config';
const BASE_URL = `${API_URL}/inventory-counting`;

export const importInventoryFile = async (type, file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await axios.post(`${BASE_URL}/import/${type}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    withCredentials: true,
  });

  return response.data;
};

export const getInventoryImports = async (type) => {
  const response = await axios.get(`${BASE_URL}/imports`, {
    params: type ? { type } : {},
    withCredentials: true,
  });

  return response.data;
};

export const getInventoryDashboard = async ({ from, to } = {}) => {
  const response = await axios.get(`${BASE_URL}/dashboard`, {
    params: {
      ...(from ? { from } : {}),
      ...(to ? { to } : {}),
    },
    withCredentials: true,
  });

  return response.data;
};

export const getInventoryRecommendations = async () => {
  const response = await axios.get(`${BASE_URL}/recommendations`, {
    withCredentials: true,
  });

  return response.data;
};

export const createCountingPlan = async ({ items, comment }) => {
  const response = await axios.post(
    `${BASE_URL}/plans`,
    {
      items,
      comment,
    },
    {
      withCredentials: true,
    },
  );

  return response.data;
};

export const downloadPlanExcel = async (planBatchId) => {
  const response = await axios.get(`${BASE_URL}/plans/${planBatchId}/excel`, {
    responseType: 'blob',
    withCredentials: true,
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', `plan_liczenia_${planBatchId}.xlsx`);
  document.body.appendChild(link);
  link.click();

  link.remove();
  window.URL.revokeObjectURL(url);
};

export const getCountingPlans = async () => {
  const response = await axios.get(`${BASE_URL}/plans`, {
    withCredentials: true,
  });

  return response.data;
};

export const getCountingPlanReport = async (planBatchId) => {
  const response = await axios.get(`${BASE_URL}/plans/${planBatchId}/report`, {
    withCredentials: true,
  });

  return response.data;
};

export const getCumulativeReport = async ({ from, to } = {}) => {
  const response = await axios.get(`${BASE_URL}/report/cumulative`, {
    params: {
      ...(from ? { from } : {}),
      ...(to ? { to } : {}),
    },
    withCredentials: true,
  });

  return response.data;
};

export const sendInventorySummaryMail = async ({
  from,
  to,

  dashboardUrl,
}) => {
  const response = await axios.post(
    `${BASE_URL}/mail/summary`,
    { from, to, dashboardUrl },
    { withCredentials: true },
  );

  return response.data;
};

export const getLastInventoryMail = async () => {
  const response = await axios.get(`${BASE_URL}/mail/last`, {
    withCredentials: true,
  });

  return response.data;
};
